
export const formattedEventDate = (dateString, excludeOptions = {}, actualPlanYear = null, yearOfActualPlan = '') => {
    if (!dateString) return ''
  
    const [month, day] = dateString.split('/').map(Number)
    let year = parseInt(yearOfActualPlan) || new Date().getFullYear()
  
    if (actualPlanYear && actualPlanYear.plan_start_date) {
      const [planMonth, planDay] = actualPlanYear.plan_start_date.split('/').map(Number)
      if (month < planMonth || (month === planMonth && day < planDay)) {
        year++
      }
    }
    // For "2/29" in non-leap years, new Date(year, 1, 29) auto-rolls to March 1,
    // which is the correct compliance behavior.
    const date = new Date(year, month - 1, day)
  
    const optionsFormatDate = {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }
  
    Object.keys(excludeOptions).forEach((excludeOption) => {
      if (excludeOptions[excludeOption]) {
        delete optionsFormatDate[excludeOption]
      }
    })
  
    let formattedDate = date.toLocaleDateString('en-US', optionsFormatDate)
  
    if (!excludeOptions.weekday) {
      formattedDate = formattedDate.replace(/,/, '')
    }
    return formattedDate
  }
  
  export const formatDateToSendReminder = (dateString, actualPlanYear = null, yearOfActualPlan = '') => {
    if (!dateString) return ''
    
    const [month, day] = dateString.split('/').map(Number)
    let year = parseInt(yearOfActualPlan) || new Date().getFullYear()
  
    if (actualPlanYear && actualPlanYear.plan_start_date) {
      const [planMonth, planDay] = actualPlanYear.plan_start_date.split('/').map(Number)
      if (month < planMonth || (month === planMonth && day < planDay)) {
        year++
      }
    }
    
    const formattedMonth = month.toString().padStart(2, '0')
    const formattedDay = day.toString().padStart(2, '0')
    
    return `${year}-${formattedMonth}-${formattedDay}`
  }
  

  export const formatDateGoogleReminders = (dateString) => {
    if (!dateString) return ''
    
    const [year, month, day] = dateString.split('-')
    const date = new Date(year, month - 1, day)
  
    const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ]
    
    return `${daysOfWeek[date.getDay()]} ${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`
  }
  

  export const calculateDaysDifference = (endDate, startDate) => {
    let start = new Date(startDate)
    let end = new Date(endDate)
  
    if (start.getTime() === end.getTime()) return 0
    if (end < start) [start, end] = [end, start]
  
    let workingDays = 0
    for (let date = new Date(start); date < end; date.setDate(date.getDate() + 1)) {
      if (date.getDay() !== 0 && date.getDay() !== 6) workingDays++
    }
  
    return workingDays
  }

  export const daysDifferenceGoogleReminder = (date1, date2) => {
    if (!date1 || !date2) return undefined
  
    const [year1, month1, day1] = date1.split('-').map(Number)
    const [year2, month2, day2] = date2.split('-').map(Number)
  
    const d1 = new Date(year1, month1 - 1, day1)
    const d2 = new Date(year2, month2 - 1, day2)
  
    let days = 0
    const [startDate, endDate] = d1 < d2 ? [d1, d2] : [d2, d1]
  
    let currentDate = new Date(startDate)
    currentDate.setDate(currentDate.getDate())
  
    while (currentDate < endDate) {
      if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
        days++
      }
      currentDate.setDate(currentDate.getDate() + 1)
    }
  
    return days
  }

  export const subtractDaysFromDate = (dateString, daysToSubtract) => {
    const [year, month, day] = dateString.split('-').map(Number)
    let date = new Date(Date.UTC(year, month - 1, day))
  
    while (daysToSubtract > 0) {
      date.setUTCDate(date.getUTCDate() - 1)
      if (date.getUTCDay() !== 6 && date.getUTCDay() !== 0) {
        daysToSubtract--
      }
    }
  
    const resultYear = date.getUTCFullYear()
    const resultMonth = (date.getUTCMonth() + 1).toString().padStart(2, '0')
    const resultDay = date.getUTCDate().toString().padStart(2, '0')
    
    return `${resultYear}-${resultMonth}-${resultDay}`
  }

  export const getTodayDate = () => {
    return new Date()
      .toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
      .split('/')
      .sort((a, b) => b.length - a.length)
      .join('-')
  }

  /**
   * Determines if a given year is a leap year
   * @param {number} year - The year to check
   * @returns {boolean} - True if the year is a leap year, false otherwise
   */
  export const isLeapYear = (year) => {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
  }

  /**
   * Parse a "YYYY-MM-DD" string as local midnight, avoiding the UTC shift
   * that occurs with new Date("YYYY-MM-DD").
   * @param {string} dateStr - Date in "YYYY-MM-DD" format
   * @returns {Date}
   */
  export const parseLocalDate = (dateStr) => {
    const [y, m, d] = dateStr.split('-').map(Number)
    return new Date(y, m - 1, d)
  }

  /**
   * Format a local Date as "YYYY-MM-DD" without going through UTC
   * (unlike toISOString which converts to UTC first).
   * @param {Date} date
   * @returns {string}
   */
  export const formatLocalDate = (date) => {
    const y = date.getFullYear()
    const m = String(date.getMonth() + 1).padStart(2, '0')
    const d = String(date.getDate()).padStart(2, '0')
    return `${y}-${m}-${d}`
  }

  /**
   * Subtract N business days (Mon-Fri) from a Date instance, returning a new Date.
   * Days = 0 returns a same-day copy. Does not account for holidays.
   * @param {Date} dueDate
   * @param {number} daysBefore
   * @returns {Date|null}
   */
  export const subtractBusinessDays = (dueDate, daysBefore) => {
    if (!(dueDate instanceof Date) || isNaN(dueDate)) return null
    if (typeof daysBefore !== 'number' || daysBefore < 0) return null
    let remaining = daysBefore
    const d = new Date(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate())
    while (remaining > 0) {
      d.setDate(d.getDate() - 1)
      const day = d.getDay()
      if (day === 0 || day === 6) continue // skip Sunday(0) & Saturday(6)
      remaining--
    }
    return d
  }